import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const HrActionsTemplatesRoutes = [
    {
        "url": "/brand/:brand_id/hr-actions-templates",
        "name": "appLayout.harriSH.hrActionsTemplates",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "hrActionsTemplates",
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hr-actions-templates/hr-actions-templates.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/hr-actions-templates`,
        "name": "appLayout.harriSH.access-portal.settings.hrActionsTemplates",
        "showSettingsHeader": true,
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "hrActionsTemplates",
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', 'brandServices', async function ($stateParams, $state, hmapService, userPermissions, brandServices) {
                const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
                const [policyParser, isHRActionsEnabled] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrandId),
                    brandServices.check(brandServices.SERVICES.HR_ACTIONS, activeBrandId)
                ]);
                if (!isHRActionsEnabled || !policyParser.has(userPermissions.PERMISSIONS['MANAGE_HR_ACTIONS_TEMPLATES'])) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
                const gpPolicy = await hmapService.loadGPPlociy(activeBrandId);
                const activeBrandPolicy = gpPolicy?.brands?.find((entry) => entry.id === activeBrandId);
                if (activeBrandPolicy?.actions[0] !== 'ALL') {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hr-actions-templates/hr-actions-templates.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/manage-actions",
        "name": "appLayout.harriSH.hrActionsTemplates.manage",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                component: 'hrActionsTemplatesMain',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates", 'centralized-settings']
        },
    },
    {
        "url": `/manage-actions/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.hrActionsTemplates.manage",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showSettingsHeader": true,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                component: 'hrActionsTemplatesMain',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates", 'centralized-settings']
        },
    },
    {
        "url": "/create-action?template_id&is_settings&edit_mode",
        "name": "appLayout.harriSH.hrActionsTemplates.create",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                "component": 'manageHrActionTemplate',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates", 'centralized-settings']
        },
    },
    {
        "url": `/create-action/${hmapPathParamRegex}?template_id&is_settings&edit_mode`,
        "name": "appLayout.harriSH.access-portal.settings.hrActionsTemplates.create",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                "component": 'manageHrActionTemplate',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates", 'centralized-settings']
        },
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission_management", "authority_to_recruit", "rejection_templates", "restricted_positions", "branded_comms", "document_uploader", "offer_templates", "mice", "chat_bot", "auto_wage_matrix", "blocked_terminated_employees", "hr_actions_templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/hr-actions-templates/hr-actions-templates.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=hr-actions-templates.routes.js.map